import React, { Component } from "react";

import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

import avatar1 from "../../assets/images/users/avatar-1.jpg";
import profileImg from "../../assets/images/profile-img.png";
import Notiflix from "notiflix";


class WelcomeComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Details:[],
            Logintime:''
        };
    }

    componentDidMount()
    {
        Notiflix.Loading.Init({
            svgColor : 'rgb(171, 61, 0)'
           
          });


          var login=localStorage.getItem('LoginDetail');
          var details=JSON.parse(login)
// console.log(details)


var lastlogin=localStorage.getItem('lastlogin');
var LastDateTime=JSON.parse(lastlogin)

// console.log(LastDateTime)
this.setState({
    Details:details[0],
    Logintime:LastDateTime
})

    }

    

    render() {
        // console.log(this.state.Details.fld_name)
        return (
            <React.Fragment>
                <Card className="overflow-hidden" style={{height:'184px'}}>
                    <div className="maxXchange-bg-soft-pink">
                        <Row>
                            <Col xs="7">
                                <div className="maxXchange-text p-3">
                                    <h5 className="maxXchange-text">Welcome {this.state.Details.fld_name} !</h5>
                                    <p>Shanthi Jewellers Dashboard</p>
                                </div>
                            </Col>
                            <Col xs="5" className="align-self-end">
                                <img src={profileImg} alt="" className="img-fluid" />
                            </Col>
                        </Row>
                    </div>
                    <CardBody className="pt-0">
                        <Row>
                            <Col sm="6">
                               <div className="pt-4">
                               <h5 className="font-size-15 text-truncate">{this.state.Details.fld_name}</h5>
        <p className="text-muted mb-0 text-truncate">{this.state.Details.fld_designation}</p>
                               </div>
       
                            </Col>

                            <Col sm="6">
                                <div className="pt-2">
                                    <Row>
                                        <Col xs="12">
                                            <h5 className="font-size-15">Last Login</h5>
        <p className="text-muted mb-0"> {this.state.Logintime}</p>
                                        </Col>
                                     
                                    </Row>
                                    {/* <div className="mt-4">
                                        <Link to="" className="btn maxXchange-btn waves-effect waves-light btn-sm">View Profile <i className="mdi mdi-arrow-right ml-1"></i></Link>
                                    </div> */}
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}

export default WelcomeComp;
